import { TypeCommon } from "models/common";

export const msalConfig: TypeCommon = {
  auth: {
    clientId: "b23965c2-9b6a-4a03-af05-99c4d832b5da",
    authority:
      "https://login.microsoftonline.com/84fd1d51-835a-4af7-ac34-64c2efe23907",
    redirectUri: "https://staging.summitgco.com/login",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};
